import React from 'react';
import styled, { keyframes } from 'styled-components';
import { theme } from '../../styles/theme';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const SpinnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing.xl};
`;

const Spinner = styled.div`
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border: 2px solid ${({ theme }) => theme.colors.gray200};
  border-top: 2px solid ${({ theme }) => theme.colors.primary};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

const LoadingText = styled.p`
  margin-top: ${({ theme }) => theme.spacing.md};
  color: ${({ theme }) => theme.colors.gray600};
  font-size: ${({ theme }) => theme.typography.fontSize.sm};
`;

function LoadingSpinner({ 
  size = 32, 
  text = 'Loading...', 
  showText = true,
  fullScreen = false 
}) {
  const content = (
    <>
      <Spinner $size={size} />
      {showText && <LoadingText>{text}</LoadingText>}
    </>
  );

  if (fullScreen) {
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        zIndex: theme.zIndex.modal,
      }}>
        <SpinnerContainer>
          {content}
        </SpinnerContainer>
      </div>
    );
  }

  return (
    <SpinnerContainer>
      {content}
    </SpinnerContainer>
  );
}

export default LoadingSpinner;
